export default __webpack_public_path__ + "static/media/chili-paper.e8f3f8cb.svg";